module.exports = __webpack_public_path__ + "img/remove.9a78f2ef.svg";